import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { withTranslation, WithTranslation } from 'react-i18next';

import { MonitorIcon } from '@icons';
import SwipeableDrawer from '@core/dashboard/components/SwipeableDrawer';
import { useScreenShare } from '@core/dashboard/components/HomeBottomBar/ScreenShareButton';
import { useCommunications } from '@core/communications/providers/CommunicationsProvider';
import BasicButton from '@components/BasicButton';
import { useTrainerTools } from '@features/TrainerTools';

import { useStyles } from './styles';

const StopSharingModal = ({ t: translate }: WithTranslation) => {
  const { isSharingScreen } = useCommunications();
  const handleShareScreen = useScreenShare();
  const { open: isTrainerToolsOpen, setOpen: setOpenTrainerTools } =
    useTrainerTools();

  const classes = useStyles();

  useEffect(() => {
    if (isSharingScreen) {
      setOpenTrainerTools(false);
    }
  }, [isSharingScreen]);

  if (!isSharingScreen) {
    return null;
  }

  const handleClick = () => {};

  return (
    <SwipeableDrawer
      position={{ vertical: 'bottom', horizontal: 'left' }}
      open={isSharingScreen && !isTrainerToolsOpen}
      onOpen={handleClick}
      onClose={handleClick}
    >
      <Box sx={classes.root}>
        <MonitorIcon sx={classes.icon} />
        <Typography sx={classes.text}>You’re sharing your screen</Typography>
        <BasicButton primary onClick={handleShareScreen} sx={classes.button}>
          {translate('webcamShare.stopSharing')}
        </BasicButton>
      </Box>
    </SwipeableDrawer>
  );
};

export default withTranslation()(StopSharingModal);
